import * as React from "react"

const YoutubeIcon = (props) => (
  <svg
    width={21}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.676 2.645A2.392 2.392 0 0 0 17.988.922C16.477.5 10.5.5 10.5.5S4.488.5 2.977.922a2.392 2.392 0 0 0-1.688 1.723C.867 4.12.867 7.285.867 7.285s0 3.13.422 4.64c.211.845.879 1.477 1.688 1.688C4.488 14 10.5 14 10.5 14s5.977 0 7.488-.387a2.345 2.345 0 0 0 1.688-1.687c.422-1.512.422-4.64.422-4.64s0-3.165-.422-4.641ZM8.53 10.133V4.438l4.992 2.847-4.992 2.848Z"
      fill="#4952E3"
    />
  </svg>
)

export default YoutubeIcon
